"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvaFolderPath = exports.CanvaFolderName = exports.ShutterstockFolderPath = exports.ShutterstockFolderName = exports.FILE_DETAILS_PATH = exports.ImageEditorLocations = exports.THUMBNAILS_FOLDER_NAME = exports.PATH_TO_VIDEO_HOSTING_INFO = exports.IMG_WIDTH_IN_DETAIL_PANEL = exports.Limits = exports.VideoProviders = exports.MAX_IMG_SIZE_FOR_THUMBNAIL = exports.UserInferredRoles = exports.VidyardTosStatus = exports.ContentCategories = exports.TypeToExtensions = exports.FileTypes = exports.UrlSchemes = exports.CdnHostnames = exports.MessageTypes = exports.RequestStatus = exports.TrackEventTypes = exports.DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS = exports.IMAGE_OPTIMIZATION_GATE = exports.FILE_MANAGER_ACCESS = exports.DIRECT_FILE_LINK_ACCESS = exports.MARKETING_VIDEO_SCOPE = exports.CANVA_GATE = exports.VIDEO_EXPERIMENTS_GATE = exports.NOTIFICATION_EVENT = exports.TRACK_EVENT = exports.MINIMUM_FETCH_FILES_LIMIT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Immutable$Map;

var MINIMUM_FETCH_FILES_LIMIT = 40;
exports.MINIMUM_FETCH_FILES_LIMIT = MINIMUM_FETCH_FILES_LIMIT;
var TRACK_EVENT = '@@usage';
exports.TRACK_EVENT = TRACK_EVENT;
var NOTIFICATION_EVENT = 'notification';
exports.NOTIFICATION_EVENT = NOTIFICATION_EVENT;
var VIDEO_EXPERIMENTS_GATE = 'video-experiments';
exports.VIDEO_EXPERIMENTS_GATE = VIDEO_EXPERIMENTS_GATE;
var CANVA_GATE = 'FileManager:Canva';
exports.CANVA_GATE = CANVA_GATE;
var MARKETING_VIDEO_SCOPE = 'marketing-video';
exports.MARKETING_VIDEO_SCOPE = MARKETING_VIDEO_SCOPE;
var DIRECT_FILE_LINK_ACCESS = 'direct-file-link-access';
exports.DIRECT_FILE_LINK_ACCESS = DIRECT_FILE_LINK_ACCESS;
var FILE_MANAGER_ACCESS = 'file-manager-access';
exports.FILE_MANAGER_ACCESS = FILE_MANAGER_ACCESS;
var IMAGE_OPTIMIZATION_GATE = 'FM:imageoptimizations';
exports.IMAGE_OPTIMIZATION_GATE = IMAGE_OPTIMIZATION_GATE;
var DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS = ['svg', 'htm', 'html', 'js', 'xml'];
exports.DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS = DIRECT_CDN_LINK_INACCESSIBLE_EXTENSIONS;
var TrackEventTypes = (0, _keyMirror.default)({
  INTERACTION: null,
  ERROR: null,
  USAGE: null
});
exports.TrackEventTypes = TrackEventTypes;
var RequestStatus = (0, _keyMirror.default)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null,
  NOTFOUND: null
});
exports.RequestStatus = RequestStatus;
var MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
/* 
** This constant is used in resize function, 
** CdnHostnames.qa redirects to CdnHostnames.qaNet
** Both QA host-names allow resizing
** For file URL accessibility, using only CdnHostnames.qaNet
** will suffice. Check FileManagerDashboard/components/FileUrl
*/

exports.MessageTypes = MessageTypes;
var CdnHostnames = {
  qa: 'cdn2.hubspotqa.com',
  qaNet: 'cdn2.hubspotqa.net',
  prod: 'cdn2.hubspot.net'
};
exports.CdnHostnames = CdnHostnames;
var UrlSchemes = (0, _keyMirror.default)({
  SIMPLIFIED: null,
  LEGACY: null
});
exports.UrlSchemes = UrlSchemes;
var FileTypes = (0, _keyMirror.default)({
  IMG: null,
  MOVIE: null,
  DOCUMENT: null,
  AUDIO: null,
  OTHER: null
});
exports.FileTypes = FileTypes;

var TypeToExtensions = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, FileTypes.IMG, new _immutable.default.Set(['jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff', 'ico', 'bmp', 'webp'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.MOVIE, new _immutable.default.Set(['mov', 'avi', 'flv', 'wmv', 'rm', '3gp', '3g2', 'asf', 'asx', 'mpg', 'mp4', 'mpeg', 'swf', 'm4v', 'webm'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.DOCUMENT, new _immutable.default.Set(['doc', 'docx', 'xls', 'xlsx', 'pdf', 'ppt', 'pptx', 'csv', 'xml', 'pps', 'key'])), (0, _defineProperty2.default)(_Immutable$Map, FileTypes.AUDIO, new _immutable.default.Set(['aif', 'm4a', 'mp3', 'mpa', 'ra', 'wav', 'wma'])), _Immutable$Map));

exports.TypeToExtensions = TypeToExtensions;

var ContentCategories = _immutable.default.Map({
  UNMAPPED: 0,
  LANDING_PAGE: 1,
  EMAIL: 2,
  BLOG_POST: 3,
  SITE_PAGE: 4,
  LEGACY_PAGE: 5,
  KNOWLEDGE_ARTICLE: 6
});

exports.ContentCategories = ContentCategories;
var VidyardTosStatus = (0, _keyMirror.default)({
  ACCEPTED: null,
  HIDDEN: null,
  NOT_ASKED: null,
  DISABLED: null
});
exports.VidyardTosStatus = VidyardTosStatus;

var UserInferredRoles = _immutable.default.Map({
  HEAVY_MARKETER: 'heavyMarketers',
  CRM_AND_SALES: 'crmAndSales',
  CRM: 'crmUsers'
});

exports.UserInferredRoles = UserInferredRoles;
var MAX_IMG_SIZE_FOR_THUMBNAIL = 999999;
exports.MAX_IMG_SIZE_FOR_THUMBNAIL = MAX_IMG_SIZE_FOR_THUMBNAIL;
var VideoProviders = (0, _keyMirror.default)({
  VIDYARD: null
});
exports.VideoProviders = VideoProviders;
var Limits = (0, _keyMirror.default)({
  EMBEDDABLE_VIDEO: null
});
exports.Limits = Limits;
var IMG_WIDTH_IN_DETAIL_PANEL = 430;
exports.IMG_WIDTH_IN_DETAIL_PANEL = IMG_WIDTH_IN_DETAIL_PANEL;
var PATH_TO_VIDEO_HOSTING_INFO = ['meta', 'video_data', 'hosting_infos'];
exports.PATH_TO_VIDEO_HOSTING_INFO = PATH_TO_VIDEO_HOSTING_INFO;
var THUMBNAILS_FOLDER_NAME = 'custom-video-thumbnails';
exports.THUMBNAILS_FOLDER_NAME = THUMBNAILS_FOLDER_NAME;
var ImageEditorLocations = (0, _keyMirror.default)({
  SOCIAL_PREVIEW: null,
  DRAWER: null
});
exports.ImageEditorLocations = ImageEditorLocations;
var FILE_DETAILS_PATH = 'file-details';
exports.FILE_DETAILS_PATH = FILE_DETAILS_PATH;
var ShutterstockFolderName = 'Stock images';
exports.ShutterstockFolderName = ShutterstockFolderName;
var ShutterstockFolderPath = "/" + ShutterstockFolderName;
exports.ShutterstockFolderPath = ShutterstockFolderPath;
var CanvaFolderName = 'Canva images';
exports.CanvaFolderName = CanvaFolderName;
var CanvaFolderPath = "/" + CanvaFolderName;
exports.CanvaFolderPath = CanvaFolderPath;